import React from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';

export default function ModalActivityDetail2(props) {
  const activityDetail2 = props.model;
  const { id } = props;

  return (
    <Modal
      title="Nueva hora para envio de archivo"
      model={activityDetail2}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="report/file-hour-report"
      state
      dataForce={{
        file_report_id: id,
      }}
    >
      <TextField
        label="Hora de ejecución"
        type="time"
        name="hora_ejecucion"
        margin="normal"
        fullWidth
        defaultValue={activityDetail2.hora_ejecucion || ''}
        required
      />
    </Modal>
  );
}
